import {PATHS} from "@/constants/routes";
import {useAuthStore} from "@/store/authStore";
import {Navigate, Outlet} from "react-router";

export const PublicRoute = () => {
  const isAuthenticated = useAuthStore(s => s.isAuthenticated);
  return isAuthenticated ? (
    <Navigate
      to={PATHS.DASHBOARD}
      replace
    />
  ) : (
    <Outlet />
  );
};
